import { oemBundle } from '@sqi/shared-schemas';
import type { OemContext } from '../../lib/auth';
import type { OemWorkspace } from '../../lib/oem-client';
import { dailyTasks, latestVisibleByRoot, taskCategories } from './task-dashboard-model';
import { stateLabel } from './display-copy';
export function ownerSummary(
  context: OemContext,
  workspace: OemWorkspace,
  sku: string,
  now: number,
) {
  if (context.audience !== 'staff' || context.role !== 'owner') return null;
  const visible = workspace.records.filter((record) =>
    context.readBundles.includes(oemBundle(record.kind)),
  );
  const records = latestVisibleByRoot(visible).filter(
    (r) => !sku || (sku === 'project' ? r.skuId === null : r.skuId === sku),
  );
  const counts = new Map<string, number>();
  for (const record of records) {
    const state =
      typeof record.content.status === 'string' && record.content.status.trim()
        ? record.content.status
        : record.state || 'unknown';
    counts.set(state, (counts.get(state) ?? 0) + 1);
  }
  const tasks = dailyTasks(records, now);
  return {
    records,
    tasks,
    statuses: [...counts].map(([key, count]) => ({
      key,
      label: key === 'unknown' ? 'ยังไม่ทราบสถานะ' : stateLabel(key),
      count,
    })),
    deadlines: taskCategories.map((category) => ({
      ...category,
      count: tasks.filter((task) => task.category === category.key).length,
    })),
  };
}
